import React, { Component } from 'react';
import "./toast.css"
class Toast extends Component {
  componentDidMount() {
    // Start the auto-close timer when the component is mounted
    this.startTimer();
  }

  componentWillUnmount() {
    // Clear the timer when the component is about to unmount
    this.clearTimer();
  }

  startTimer = () => {
    // Set a timeout to auto-close the toast after 5 seconds
    this.timer = setTimeout(() => {
      this.props.removeToast(this.props.id);
    }, 5000);
  };

  clearTimer = () => {
    // Clear the auto-close timer
    if (this.timer) {
      clearTimeout(this.timer);
    }
  };

  handleMouseEnter = () => {
    // Clear the timer when mouse enters (hover)
    this.clearTimer();
  };

  handleMouseLeave = () => {
    // Restart the timer when mouse leaves (hover out)
    this.startTimer();
  };

  render() {
    const { message, type } = this.props;
    return (
      <div
        className={`toast ${type}`}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        {message}
        {/* <button onClick={() => this.props.removeToast(this.props.id)}>Close</button> */}
      </div>
    );
  }
}

export default Toast;
